import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=dc7a6b12&"
import script from "./EditDialog.vue?vue&type=script&lang=ts&"
export * from "./EditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports